import { TabSize } from "../../types";
import { TEXT_SIZES } from "../../../text/constants";
import { Sizes } from "../../../text/types";

export const TAB_TEXT_SIZES: Record<TabSize, Sizes> = {
  small: TEXT_SIZES.SMALL,
  medium: TEXT_SIZES.MEDIUM,
  large: TEXT_SIZES.LARGE,
};
